import { Button, ButtonGroup, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateTask } from "../../actions";
import AddPageWrapper from "../general/AddPageWrapper";
import TitleBar from "../general/TitleBar";
import AnswerKey from "./AnswerKey";
const typeOptions = [
  { id: 1, name: "MCQ" },
  { id: 2, name: "Input" },
  { id: 4, name: "Open Ended" },
];
const structureOptions = [
  { id: 1, name: "Default" },
  { id: 2, name: "Group" },
  { id: 3, name: "Sequence" },
  { id: 4, name: "Open" },
];
const layoutOptions = [
  { id: 1, name: "Vertical" },
  { id: 2, name: "Horizontal" },
];
const sortingOptions = [
  { id: 1, name: "Fix Order" },
  { id: 2, name: "Random" },
];

const containerStyle = { paddingBottom: 20 };
const divStyle = { margin: 36, userSelect: "none" };
const flexStyle = { display: "flex" };
const buttonGroupWrapperStyle = {
  border: "1px solid",
  borderRadius: 5,
  backgroundColor: "var(--color-surface-subtle)",
  width: 240,
  marginRight: 60,
};
const typeButtonGroupWrapperStyle = {
  ...buttonGroupWrapperStyle,
  width: "auto",
};
const buttonGroupStyle = { paddingInline: 8, paddingBottom: 10 };
const titleWrapperStyle = { display: "flex", justifyContent: "space-around" };
const titleUnderlineStyle = { borderBottom: "1px solid" };
const normalStyle = { textTransform: "none", whiteSpace: "nowrap" };
const selectedStyle = { textTransform: "none", color: "var(--color-danger)", whiteSpace: "nowrap" };
export default function AnswerSetting({ count, task }) {
  const [expandAnswerSetting, setExpandAnswerSetting] = useState(false);
  const [settingOptions, setSettingOptions] = useState([
    { target: "type", options: typeOptions },
  ]);
  const dispatch = useDispatch();
  const update = (count, head, target, text, event) =>
    dispatch(updateTask(count, head, target, text, event));
  const { type, structure, layout, sorting } = task;
  useEffect(() => {
    if (type === 1) {
      setSettingOptions([
        { target: "type", options: typeOptions },
        { target: "layout", options: layoutOptions },
        {
          target: "structure",
          options: structureOptions.filter((s) => s.id !== 4),
        },
        { target: "sorting", options: sortingOptions },
      ]);
    } else if (type === 2) {
      setSettingOptions([
        { target: "type", options: typeOptions },
        {
          target: "structure",
          options: structureOptions.filter((s) => s.id !== 3),
        },
      ]);
    } else if (type === 4) {
      setSettingOptions([{ target: "type", options: typeOptions }]);
    } else setSettingOptions([{ target: "type", options: typeOptions }]);
  }, [type]);
  console.log(task, "answer");
  return (
    <Grid container style={containerStyle}>
      <TitleBar
        title="Answer Setting"
        state={expandAnswerSetting}
        setState={setExpandAnswerSetting}
      />

      {expandAnswerSetting && (
        <AddPageWrapper>
          <div style={divStyle}>
            <div style={flexStyle}>
              {settingOptions.map(({ target, options }, index) => (
                <div
                  key={index}
                  style={
                    target === "type"
                      ? typeButtonGroupWrapperStyle
                      : buttonGroupWrapperStyle
                  }
                >
                  <div style={titleWrapperStyle}>
                    <h2 style={titleUnderlineStyle}>
                      {target.charAt(0).toUpperCase() + target.slice(1)}
                    </h2>
                  </div>
                  <ButtonGroup
                    fullWidth={target !== "type"}
                    variant="outlined"
                    style={buttonGroupStyle}
                  >
                    {options.map(({ id, name }, i) => (
                      <Button
                        key={i}
                        style={
                          id === task[target] ? selectedStyle : normalStyle
                        }
                        onClick={() => update(count, "taskText", target, id)}
                      >
                        {name}
                      </Button>
                    ))}
                  </ButtonGroup>
                </div>
              ))}
            </div>
            {(type === 1 &&
              layout !== "" &&
              sorting !== "" &&
              structure !== "") ||
            (type === 2 && structure !== "") ||
            type === 4 ? (
              <AnswerKey count={count} task={task} />
            ) : null}
          </div>
        </AddPageWrapper>
      )}
    </Grid>
  );
}
